export default {
    name: 'degreeOfSoil',
    serverName: '​/api/v1/rb_calculator/degree_of_soil_moisture/',
    apiUrl: '/api/v1/rb_calculator/degree_of_soil_moisture/'
};
